/* Copyright (C) 2021 ev-i Informationstechnologie GmbH */

export enum PlotTemplateResolver {
    REVIEW_CYCLE = "REVIEW_CYCLE",
    PROJECT_PARTICIPATION = "PROJECT_PARTICIPATION",
    MANUAL = "MANUAL"
}
